/*
 * Copyright (c) 2023 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {SKU} from "../../../data/mypuratos";
import {ImageType, selectRendition} from "../../../data/aem.model";
import {withI18N} from "../../hoc/withI18N";
import {ProductsInCartOverlay} from "../finder/ProductsInCartOverlay";
import {ConditionalWrapper} from "../../atoms/helper/ConditionalWrapper";
import {StockInformation} from "../../atoms/details/StockInformation";
import {DesktopOnly} from "../../my-puratos/atoms/table/Table";


export const CONTEXTS = {
    RELATED_PRODUCTS: "RELATED_PRODUCTS"
};

class _ProductColumn extends React.Component {

    static propTypes = {
        product: PropTypes.shape(SKU),
        fallbackImage: PropTypes.shape(ImageType),
        showStock: PropTypes.bool
    };

    renderTitle = (context, product, addEvent, position) => {
        switch (context) {
            case CONTEXTS.RELATED_PRODUCTS:
                return <ConditionalWrapper condition={product.productUrl}
                                           wrapper={children => <a href={product.productUrl} onClick={() => addEvent(product, position)}
                                                                   onMouseDown={(e) => e.button === 1 && addEvent(product, position)}>{children}</a>}>
                    <h6 className={"block bold p-sans p-small p-margin-none"}>{product.aemProdName}</h6>
                </ConditionalWrapper>;
            default:
                return <div>
                    <ConditionalWrapper condition={product.productUrl}
                                        wrapper={children => <a href={product.productUrl} onClick={() => addEvent(product, position)}
                                                                onMouseDown={(e) => e.button === 1 && addEvent(product, position)}>{children}</a>}>
                        <h6 className="p-sans p-margin-none p-margin-right-xs">{product.aemProdName}</h6>
                    </ConditionalWrapper>
                </div>
        }
    };

    render() {
        const {product, fallbackImage, context, translate, addEvent, position, showStock = false} = this.props;

        return (<React.Fragment>
            <div className="full-height table-group-cell col-md-3 ie-align-center">
                <ConditionalWrapper condition={product.productUrl}
                                    wrapper={children => <a href={product.productUrl} onClick={() => addEvent(product, position)}
                                                            onMouseDown={(e) => e.button === 1 && addEvent(product, position)}>{children}</a>}>
                    {product.materialNumber &&
                    <ProductsInCartOverlay id={product.materialNumber} rounded="sm" fading small/>}
                    {(product.skuImageUrl || product.imageUrl || fallbackImage) &&
                    <img className="my-puratos__packshot-image"
                         src={product.skuImageUrl || product.imageUrl || selectRendition(fallbackImage)}
                         alt={product.referenceTitle || product.title || product.aemProdName}/>}
                </ConditionalWrapper>
            </div>
            <div className={`full-height table-group-cell p-flex p-flex-column p-flex-justify-content-space-evenly col-sm-12 col-md-9`}>
                {this.renderTitle(context, product, addEvent, position)}
                <span className="text-muted p-xsmall block p-serif-nr">
                    {product.materialDescription}
                </span>
                <span className="text-muted p-xsmall block p-serif-nr">
                    {translate("Material n°")}: {product.materialNumber}
                </span>
                {(showStock && product.hasPrice) && <DesktopOnly size={"760px"}>
                    <StockInformation type={product.stockType} showTooltip={false}/>
                </DesktopOnly>}
            </div>
        </React.Fragment>);
    }

}

export const ProductColumn = withI18N(_ProductColumn);
